export default {
  COMPENSATION: 'COMPENSATION',
  OTHER: 'OTHER',
};
